import { get, handleResponse, postAuth } from "./base.service";
import { CONTROLLER, ACTION } from "../utilities/api.constants";

const decodeBase64ToUint8Array = (base64Value) => {
  let normalized = String(base64Value).replace(/-/g, "+").replace(/_/g, "/");
  const padding = normalized.length % 4;

  if (padding) {
    normalized += "=".repeat(4 - padding);
  }

  const byteCharacters = atob(normalized);
  const byteNumbers = new Array(byteCharacters.length);

  for (let i = 0; i < byteCharacters.length; i += 1) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  return new Uint8Array(byteNumbers);
};

const getMimeTypeFromFileName = (fileName) => {
  const ext = fileName.includes(".")
    ? fileName.substr(fileName.lastIndexOf(".") + 1).toLowerCase()
    : "";

  if (ext === "pdf") {
    return "application/pdf";
  }

  if (ext === "jpg" || ext === "jpeg") {
    return "image/jpeg";
  }

  if (ext === "png") {
    return "image/png";
  }

  return "application/octet-stream";
};

const openDownloadedFile = (blob, fileName) => {
  const ext = fileName.includes(".")
    ? fileName.substr(fileName.lastIndexOf(".") + 1).toLowerCase()
    : "";
  const shouldDownload = !["jpg", "jpeg", "png", "pdf"].includes(ext);
  const fileURL = URL.createObjectURL(blob);

  if (shouldDownload) {
    const anchor = document.createElement("a");
    anchor.href = fileURL;
    anchor.download = fileName;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  } else {
    window.open(fileURL);
  }

  URL.revokeObjectURL(fileURL);
};

const extractDemandFilePayload = (result) => {
  const responseCode = result?.responseCode ?? result?.ResponseCode;
  const isSuccess = result?.success ?? result?.Success;

  if (isSuccess === false) {
    throw new Error(result?.message || result?.Message || "Doküman indirilemedi");
  }

  if (responseCode && Number(responseCode) !== 200) {
    const messages = result?.messages || result?.Messages;
    throw new Error(
      (Array.isArray(messages) && messages[0]) ||
        result?.message ||
        result?.Message ||
        "Doküman indirilemedi"
    );
  }

  const responseData = result?.data || result?.Data || result;
  const fileBase64 =
    responseData?.fileByteArray ||
    responseData?.FileByteArray ||
    "";
  const fileName =
    responseData?.fileName ||
    responseData?.FileName ||
    "dokuman";

  if (!fileBase64) {
    throw new Error("Doküman içeriği alınamadı");
  }

  return { fileBase64, fileName };
};

export const normalizeSubmitDemandOptions = (payload) => {
  let root = payload;

  if (typeof root === "string") {
    try {
      root = JSON.parse(root);
    } catch {
      return [];
    }
  }

  const list = root?.data ?? root?.Data ?? root;

  if (!Array.isArray(list)) {
    return [];
  }

  return list
    .map((option) => {
      const value = String(option.value ?? option.Value ?? "");

      return {
        value,
        label: option.label ?? option.Label ?? "",
        hint: option.hint ?? option.Hint ?? "",
        iconClass: option.iconClass ?? option.IconClass ?? "t-icon-file-text",
        cardClass: "t-smartCalculation-choiceCard--ev",
        inputId: `demand-reason-${value}`,
        showNewRibbon: Boolean(option.showNewRibbon ?? option.ShowNewRibbon),
      };
    })
    .filter((option) => option.value);
};

export const getSubmitDemandOptions = () => {
  return get(CONTROLLER.WORKFLOW + ACTION.GET_SUBMIT_DEMAND_OPTIONS).then(handleResponse);
};

export const getMemberFek = (basvuruNedeni) => {
  return get(CONTROLLER.WORKFLOW + ACTION.GET_MEMBER_FEK + "?basvuruNedeni=" + basvuruNedeni)
    .then(handleResponse);
};
export const addFeedback = (konu, aciklama, basvuruNedeni, uyeNo, adiSoyadi, tckn, babaAdi, unvan, vkn, mersisNo, iban, telNo, extra = {}) => {
  var data = {
    konu,
    aciklama,
    basvuruNedeni,
    uyeNo, 
    adiSoyadi, 
    tckn, 
    babaAdi, 
    unvan, 
    vkn, 
    mersisNo, 
    iban, 
    telNo,
    ...extra
  };
  return postAuth(CONTROLLER.WORKFLOW + ACTION.ADD_FEEDBACK, data).then(
    handleResponse
  );
};

export const addOdemeUyumsuzlukTalep = (formData) => {
  return postAuth(CONTROLLER.WORKFLOW + ACTION.ODEME_UYUMSUZLUK_TALEP, formData).then(
    handleResponse
  );
};

export const askToAgent = (konu, aciklama) => {
  var data = {
    konu,
    aciklama,
    basvuruNedeni: "2"
  };
  return postAuth(CONTROLLER.WORKFLOW + ACTION.ASK_TO_AGENT, data).then(
    handleResponse
  );
};

export const getMyDemand = () => {
  return get(CONTROLLER.WORKFLOW + ACTION.GET_MY_DEMANDS).then(handleResponse);
};

export const downloadDemandFileService = (id, documentName) => {
  return get(`${CONTROLLER.WORKFLOW}${ACTION.DOWNLOAD_DEMAND_FILE}?id=${id}`)
    .then(handleResponse)
    .then((result) => {
      const { fileBase64, fileName } = extractDemandFilePayload(result);
      const downloadName = documentName || fileName;
      const mimeType = getMimeTypeFromFileName(downloadName);
      const blob = new Blob([decodeBase64ToUint8Array(fileBase64)], { type: mimeType });

      openDownloadedFile(blob, downloadName);
    });
};

export const getMemberIban = () => {
  return get(CONTROLLER.WORKFLOW + ACTION.GET_MEMBER_IBAN)
    .then(handleResponse);
};